/* eslint-disable @typescript-eslint/camelcase */
import {
  AddExchangeRateRequestInterface,
  EditExchangeRateRequestInterface
} from "../contracts/ExchangeRateRequest";

export class AddExchangeRateApiRequest
  implements AddExchangeRateRequestInterface {
  private from: string;
  private to: string;
  private exchange_rate: number;
  private effective_date: string;

  constructor(
    from: string,
    to: string,
    exchange_rate: number,
    effective_date: string
  ) {
    this.from = from;
    this.to = to;
    this.exchange_rate = exchange_rate;
    this.effective_date = effective_date;
  }

  public toJSON() {
    const from = this.from;
    const to = this.to;
    const exchange_rate = String(this.exchange_rate);
    const effective_date = this.effective_date;

    return JSON.stringify({
      from,
      to,
      exchange_rate,
      effective_date
    });
  }
}

export class EditExchangeRateApiRequest
  implements EditExchangeRateRequestInterface {
  private id: number;
  private exchange_rate: number;
  private effective_date: string;

  constructor(id: number, exchange_rate: number, effective_date: string) {
    this.id = id;
    this.exchange_rate = exchange_rate;
    this.effective_date = effective_date;
  }

  public toJSON() {
    const exchange_rate_id = this.id;
    // horde's UpdateExchangeRateRequest.ExchangeRate is typed string (parsed
    // via shopspring/decimal); an unquoted JSON number fails Echo's binder.
    const exchange_rate = String(this.exchange_rate);
    const effective_date = this.effective_date;

    return JSON.stringify({
      exchange_rate_id,
      exchange_rate,
      effective_date
    });
  }
}
